var map = {
	"./all_black.png": 48127,
	"./black.png": 87605,
	"./british_shorthair.png": 65578,
	"./calico.png": 86705,
	"./cat_collar.png": 95966,
	"./jellie.png": 49054,
	"./ocelot.png": 43437,
	"./persian.png": 49265,
	"./ragdoll.png": 16399,
	"./red.png": 14392,
	"./siamese.png": 99226,
	"./tabby.png": 60241,
	"./white.png": 55626
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73804;